import React from "react";
import { useTranslation } from "react-i18next";
import MapSettingsSkeleton from "./Skeleton";
import MapSettingsForm from "./Form";
import {
  useGetMapSettings,
  useUpdateMapSettings,
} from "../../../../hooks/queries/mapSettings";

export default function MapSettings(props) {
  const { t } = useTranslation();
  // const appContext = useContext(AppContext);
  const { data, isError } = useGetMapSettings();

  if (isError) return <p>{t("settings.common.error")}</p>;
  if (data) return <MapSettingsForm initialMapSettings={data} />;
  return <MapSettingsSkeleton />;
}
